"use strict";

exports.__esModule = true;
exports.default = void 0;

var noop = function noop() {};

var _default = noop;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/bootstrap-vue/es/utils/noop.js
// module id = ./node_modules/bootstrap-vue/es/utils/noop.js
// module chunks = 6